module.exports = __webpack_public_path__ + "img/bus-icon.3b7bb707.svg";